import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

const faqData = [
  {
    heading: "Who is the Hire Remote Team For?",
    text: "Our applicants are developers with 3-5+ years of relevant work experience.",
  },
  {
    heading:
      "What is the average salary of developers getting hired by Hire Remote Teams?",
    text: "The average salary for developers who get hired by Hire Remote Teams is starting from 7 figures.",
  },
  {
    heading:
      "Do you have positions for any other profile apart from developers?",
    text: "Currently, we have openings only for the developers because of the volume of job demands from our clients. But in the future, we might expand to other roles too. Do check out our careers page periodically to see if we could offer a position that suits your skills and experience.",
  },
  {
    heading: "Do I need to pay any fee upfront?",
    text: "No, the service is absolutely free for developers who sign up.",
  },
  {
    heading: "Are fresh graduates getting hired by the Hire Remote Team?",
    text: "Ideally, a remote developer needs to have at least 3-5 years of relevant experience to get hired, but at the same time, we don’t say no to exceptional developers. Take our test to find out if we could offer something exciting for you.",
  },
];

const Faq = () => {
  return (
    <>
      <section className="faqSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading" data-aos="slide-right">
                <h3>
                  Frequently Asked <span>Questions</span>
                </h3>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Accordion>
                {faqData.map((each, i) => (
                  <AccordionItem
                    className="ac-item"
                    key={i}
                    data-aos="slide-up"
                  >
                    <AccordionItemHeading>
                      <AccordionItemButton className="ac-heading">
                        {each.heading}
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel className="ac-panel">
                      <p>{each.text}</p>
                    </AccordionItemPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;
